import { get, post } from './index';
export const getDevices = data => {
  return post({
    url: '/dm/query',
    data
  });
};
export const getDeviceList = params => {
  return post({
    url: '/dm/list',
    data: {
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
      mo: params.mo,
      name: params.name,
      state: params.state,
      sortFiled: params.sortFiled,
      isAsc: params.isAsc
    }
  });
};
export const getDevice = mo => {
  return post({
    url: '/dm/query/mo',
    data: {
      mo
    }
  });
};
export const getLog = mo => {
  return post({
    url: '/dm/history',
    data: {
      mo
    }
  });
};
export const exportDevice = data => {
  return post({
    url: '/dm/export',
    data
  });
};
export const exportDeviceTemp = () => {
  return get({
    url: '/dm/node/template',
    data: {}
  });
};
export const deleteDevice = data => {
  return post({
    url: '/dm/delete',
    data
  });
};
export const addDevice = params => {
  return post({
    url: '/dm/add',
    data: {
      mo: params.mo,
      name: params.name,
      ip: params.ip,
      port: `${params.port}`,
      connectModel: params.connectModel,
      isBmc: params.isBmc,
      user: params.user,
      password: params.password,
      integrateType: params.integrateType,
      groupId: params.groupId,
      hostId: params.hostId
    }
  });
};
export const updateDevice = params => {
  return post({
    url: '/dm/update',
    data: {
      id: params.id,
      mo: params.mo,
      name: params.name,
      ip: params.ip,
      port: `${params.port}`,
      connectModel: params.connectModel,
      isBmc: params.isBmc,
      user: params.user,
      password: params.password,
      integrateType: params.integrateType,
      groupId: params.groupId,
      hostId: params.hostId
    }
  });
};
export const integrateDevice = (mo, isBmc, token) => {
  return post({
    url: '/dm/integrate',
    data: {
      mo,
      isBmc,
      token
    }
  });
};
export const stopDevice = (mo, isBmc) => {
  return post({
    url: '/dm/terminate',
    data: {
      mo,
      isBmc
    }
  });
};
export const getToken = (mo, user, password) => {
  return post({
    url: '/bmcLogin',
    data: {
      mo,
      user,
      password
    }
  });
};
export const getUpgradeNodeList = params => {
  return post({
    url: '/ota/task/node/list',
    data: {
      currentVersion: params.currentVersion,
      pathId: params.pathId
    }
  });
};
export const getPathQuery = params => {
  return post({
    url: '/ota/path/actions/query',
    data: {
      currentVersion: params.currentVersion,
      pkgType: params.pkgType,
      targetVersion: params.targetVersion,
      isUpdateLinux: params.isUpdateLinux
    }
  });
};
export const addUpgradeTask = params => {
  return post({
    url: '/ota/task/save',
    data: {
      moList: params.moList,
      pathId: params.pathId,
      type: params.type,
      upgradeTime: params.upgradeTime
    }
  });
};
export const getTaskList = params => {
  return post({
    url: '/ota/task/list',
    data: {
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
      mo: params.mo,
      currentVersion: params.currentVersion,
      upgradeVersion: params.upgradeVersion,
      state: params.state,
      pkgType: params.pkgType
    }
  });
};
export const getVersionList = params => {
  return post({
    url: '/ota/task/version',
    data: {
      currentVersion: params.currentVersion,
      upgradeVersion: params.upgradeVersion,
      mo: params.mo,
      state: params.state,
      pkgType: params.pkgType
    }
  });
};
export const getTaskLogs = id => {
  return post({
    url: '/ota/task/logs',
    data: {
      taskId: id
    }
  });
};
export const taskTerminate = params => {
  return post({
    url: '/ota/task/terminate',
    data: {
      taskIds: params.taskIds,
      type: params.type
    }
  });
};
export const taskDelete = params => {
  return post({
    url: '/ota/task/delete',
    data: {
      taskIds: params.taskIds,
      type: params.type
    }
  });
};
export const taskStart = params => {
  return post({
    url: '/ota/task/start',
    data: {
      taskIds: params.taskIds,
      type: 1
    }
  });
};
export const taskQuery = params => {
  return post({
    url: '/ota/task/query',
    data: {
      taskId: params.taskId
    }
  });
};
export const taskCount = () => {
  return get({
    url: '/ota/task/count'
  });
};
export const getYunGroup = () => {
  return post({
    url: '/dm/yun/group'
  });
};
export const getEnv = () => {
  return post({
    url: '/env'
  });
};
export const uploadPackage = params => {
  const formData = new FormData();
  formData.append('file', params.file);
  return post({
    url: '/fota/firmware/actions/upload',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: progressEvent => {
      const percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
      console.log('percentCompleted', percentCompleted);
    }
  });
};